import { ISearchPromosV2ResponseSchema } from '../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { TIsCompilation } from '../types/compilation';

export const mapIsCompilation = (promosResponse: ISearchPromosV2ResponseSchema): TIsCompilation => {
  const isCompilation = promosResponse.isCompilation;

  return isCompilation || false;
};
